// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sectionFive {
	background: white;
	height: auto;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	/* justify-content: center; */
}

#sectionFive-top {
	width: 100%;
	display: flex;
	flex-direction: row;
}

#sectionFive-left {
	width: 100%;
	height: 450px;
	background: #1c2640;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 10vh;
}

#sectionFive-left-head {
	font-style: normal;
	font-weight: 400;
	font-size: 36px;
	line-height: 42px;
	color: #ffffff;
	margin-bottom: 30px;
	margin-left: -210px;
}

#option1,
#option2,
#option3 {
	color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
/*	padding: 0 3% 0 3%;*/
	width: 506px;
	padding: 10px !important;
    height: auto;
/*	height: 40px;*/
	margin-top: 5%;
	background: rgba(255, 255, 255, 0.2);
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	cursor: pointer;
}

#sectionFive-right {
	padding-top: 12vh;
	width: 50%;
	height: 600px;
	background: #ec6927;
	display: flex;
	align-items: center;
	justify-content: center;
}

#sectionFive-map-right {
	width: 90%;
}

#sectionFive-bottom {
	background: rgba(157, 170, 241, 0.32);
	height: inherit;
	width: 100%;
}

#sectionFive-arrow {
	width: 3%;
	float: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/SectionFive/sectionFive.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,YAAY;CACZ,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;;;CAGC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B,uBAAuB;CACtB,YAAY;CACZ,wBAAwB;IACrB,YAAY;AAChB,iBAAiB;CAChB,cAAc;CACd,oCAAoC;CACpC,2CAA2C;CAC3C,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,qCAAqC;CACrC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,YAAY;AACb","sourcesContent":["#sectionFive {\n\tbackground: white;\n\theight: auto;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\t/* justify-content: center; */\n}\n\n#sectionFive-top {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n#sectionFive-left {\n\twidth: 100%;\n\theight: 450px;\n\tbackground: #1c2640;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding-top: 10vh;\n}\n\n#sectionFive-left-head {\n\tfont-style: normal;\n\tfont-weight: 400;\n\tfont-size: 36px;\n\tline-height: 42px;\n\tcolor: #ffffff;\n\tmargin-bottom: 30px;\n\tmargin-left: -210px;\n}\n\n#option1,\n#option2,\n#option3 {\n\tcolor: white;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n/*\tpadding: 0 3% 0 3%;*/\n\twidth: 506px;\n\tpadding: 10px !important;\n    height: auto;\n/*\theight: 40px;*/\n\tmargin-top: 5%;\n\tbackground: rgba(255, 255, 255, 0.2);\n\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\tborder-radius: 5px;\n\tcursor: pointer;\n}\n\n#sectionFive-right {\n\tpadding-top: 12vh;\n\twidth: 50%;\n\theight: 600px;\n\tbackground: #ec6927;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n#sectionFive-map-right {\n\twidth: 90%;\n}\n\n#sectionFive-bottom {\n\tbackground: rgba(157, 170, 241, 0.32);\n\theight: inherit;\n\twidth: 100%;\n}\n\n#sectionFive-arrow {\n\twidth: 3%;\n\tfloat: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
